/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { ActionButton } from '@manulife/mux';
import { Chart4 } from '@manulife/mux-cds-icons';

import './fasatLinkButton.scss';

function FasatLinkButton(props) {
  const { icon, onClick, ariaLabel } = props;
  return (
    <>
      <ActionButton
        onClick={onClick}
        className="action-btn-link"
        aria-label={ariaLabel}
        customStyle={{
          buttonStyle: {
            padding: '0',
            width: 'max-content !important',
          },
        }}
      >
        {props.children}
      </ActionButton>
      {icon
  && (
  <ActionButton
    onClick={onClick}
    aria-label={ariaLabel}
    icon={(
      <Chart4
        style={{ width: '20px', height: '30px' }}
      />
)}
  />
  )}
    </>
  );
}

export default FasatLinkButton;
